import { render, staticRenderFns } from "./pick_address.vue?vue&type=template&id=5a4df088&scoped=true&"
import script from "./pick_address.vue?vue&type=script&lang=js&"
export * from "./pick_address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4df088",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4df088')) {
      api.createRecord('5a4df088', component.options)
    } else {
      api.reload('5a4df088', component.options)
    }
    module.hot.accept("./pick_address.vue?vue&type=template&id=5a4df088&scoped=true&", function () {
      api.rerender('5a4df088', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/maps/pick_address.vue"
export default component.exports